import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { UiModule } from '../ui/ui.module';

import {
  AppIntegrationAccountControlComponent,
  LocationWarehouseGroupControlComponent,
  AppIntegrationAccountOmsStoreControlComponent,
  AppIntegrationAccountShippingMethodControlComponent,
  RfqLotSearchDropdownComponent,
  WarehouseSearchDropdownComponent,
  AppIntegrationAccountInventoryLocationControlComponent,
} from './components';
import { DirectiveModule } from './directives/directive.module';
import { PipeModule } from './pipes/pipe.module';
import {
  ApiService,
  AuthService,
  ClientApiService,
  ClientCompanyApiService,
  ClientCreditMemoApiService,
  ClientPurchaseOrderApiService,
  ClientShippingApiService,
  ClientTypeApiService,
  FactoryApiService,
  InvoiceApiService,
  LocationApiService,
  LocationWarehouseApiService,
  LocationWarehouseGroupApiService,
  LotApiService,
  OrderReturnApiService,
  PicklistApiService,
  PricingApiService,
  PricingLevelApiService,
  PurchaseOrderApiService,
  RbacApiService,
  RfqApiService,
  ShippingCarrierApiService,
  StaffApiService,
  SystemSettingApiService,
  TagApiService,
  UnitClassApiService,
  UnitOfMeasureApiService,
  ChannelApiService,
  ProductSubstitutionApiService,
  RfqUtilService,
  AgGridPaginationUtilService,
  OrderApiService,
  OrderTransferApiService,
  CustomFieldApiService,
  ScannerServiceApiService,
  RfqStockLocationApiService,
  InventoryApiService,
  AutomationBuilderApiService,
  OrderSalesApiService,
  ChannelProductMappingApiService,
  FeatureFlagUtilService,
  PermissionUtilService,
  KitApiService,
  BomApiService,
  StockApiService,
  AppIntegrationAccountProductsApiService,
  OrderClientPurchaseService,
  OrderSupplierPurchaseService,
  OrderSupplierReceivingReportsService,
  SettingService,
  OrderUtilService,
  ProductCategoryService,
  QuickbooksApiService,
} from './services';
import { EnvironmentUtilService } from './services/util';

const commonModules = [
  CommonModule,
  MatDialogModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  ReactiveFormsModule,
];

const lumModules = [
  PipeModule,
  DirectiveModule,
  SharedComponentsModule,
  UiModule,
  MaterialCustomModule,
];

const lumServices = [
  ApiService,
  AuthService,
  ClientApiService,
  ClientCompanyApiService,
  ClientCreditMemoApiService,
  ClientPurchaseOrderApiService,
  ClientShippingApiService,
  ClientTypeApiService,
  EnvironmentUtilService,
  FactoryApiService,
  InvoiceApiService,
  InvoiceApiService,
  InvoiceApiService,
  LocationApiService,
  LocationWarehouseApiService,
  LocationWarehouseGroupApiService,
  LotApiService,
  OrderReturnApiService,
  PicklistApiService,
  PricingApiService,
  PricingLevelApiService,
  RbacApiService,
  RfqApiService,
  ShippingCarrierApiService,
  StaffApiService,
  SystemSettingApiService,
  TagApiService,
  UnitClassApiService,
  UnitOfMeasureApiService,
  PurchaseOrderApiService,
  ChannelApiService,
  ProductSubstitutionApiService,
  RfqUtilService,
  AgGridPaginationUtilService,
  OrderApiService,
  OrderTransferApiService,
  CustomFieldApiService,
  ScannerServiceApiService,
  RfqStockLocationApiService,
  InventoryApiService,
  AutomationBuilderApiService,
  OrderSalesApiService,
  ChannelProductMappingApiService,
  FeatureFlagUtilService,
  PermissionUtilService,
  KitApiService,
  BomApiService,
  StockApiService,
  AppIntegrationAccountProductsApiService,
  OrderClientPurchaseService,
  OrderSupplierPurchaseService,
  OrderSupplierReceivingReportsService,
  SettingService,
  OrderUtilService,
  ProductCategoryService,
  QuickbooksApiService,
];

// NOTE: DON'T add new components here, add them to the shared-components.module.ts file
const sharedComponents = [
  AppIntegrationAccountControlComponent,
  LocationWarehouseGroupControlComponent,
  AppIntegrationAccountOmsStoreControlComponent,
  AppIntegrationAccountInventoryLocationControlComponent,
  AppIntegrationAccountShippingMethodControlComponent,
  RfqLotSearchDropdownComponent,
  WarehouseSearchDropdownComponent,
  // NOTE: DON'T add new components here, add them to the shared-components.module.ts file
];

@NgModule({
  declarations: [...sharedComponents],
  imports: [...commonModules, ...lumModules],
  providers: [...lumServices],
  exports: [...sharedComponents, ...lumModules],
})
export class SharedModule {}
